import { api, SKIP_AUTO_CONTENT_TYPE_HEADER } from './api';

// Define the RAG service
export const ragApi = api.injectEndpoints({
  reducerPath: 'ragApi',
  tagTypes: ['Documents', 'Content'],
  endpoints: (builder) => ({
    storeFile: builder.mutation({
      query: ({ file, externalId, knowledgeBaseId, metadata }) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('externalId', externalId);
        if (metadata) {
          formData.append('metadata', JSON.stringify(metadata));
        }

        return {
          url: `/api/rag/store/${knowledgeBaseId}/document`,
          method: 'POST',
          body: formData
        };
      },
      invalidatesTags: ['KnowledgeBaseDocuments']
    }),
    storeMultipleFiles: builder.mutation({
      query: ({ files, knowledgeBaseId, metadata, maxChunkCount }) => {
        const formData = new FormData();
        files.forEach((file) => {
          formData.append('files', file);
        });

        formData.append(
          'storeProperties',
          new Blob([JSON.stringify({ maxChunkCount })], {
            type: 'application/json'
          })
        );

        if (metadata) {
          formData.append(
            'metadata',
            new Blob([JSON.stringify(metadata)], {
              type: 'application/json'
            })
          );
        }

        return {
          url: `/api/rag/store/${knowledgeBaseId}/documents`,
          method: 'POST',
          body: formData,
          headers: {
            [SKIP_AUTO_CONTENT_TYPE_HEADER]: 'true'
          }
        };
      },
      invalidatesTags: ['KnowledgeBaseDocuments']
    }),
    storeContent: builder.mutation({
      query: ({ content, externalId, knowledgeBaseId, metadata }) => {
        const formData = new FormData();
        formData.append('content', content);
        formData.append('externalId', externalId);
        formData.append('knowledgeBaseId', knowledgeBaseId);
        if (metadata) {
          formData.append('metadata', JSON.stringify(metadata));
        }

        return {
          url: `/api/rag/store/content`,
          method: 'POST',
          body: formData
        };
      },
      invalidatesTags: ['KnowledgeBaseDocuments']
    })
  })
});

// Export hooks for usage in functional components
export const { useStoreFileMutation, useStoreMultipleFilesMutation, useStoreContentMutation } =
  ragApi;
